import styles from "./style.module.css";

const Spinner = () => (
	<div className={styles.loader__container}>
		<div className={styles.loader}></div>
	</div>
);

export default Spinner;
